module.exports = __webpack_public_path__ + "static/media/ic_mastercard.f85ae4a2.svg";